import React from 'react';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { Check } from 'lucide-react';
import { Dialog, DialogContent } from './components/ui/dialog';
import { Button } from './components/ui/button';

// Interface para a resposta do agendamento
interface ScheduleResponse {
  _id: string;
  appointmentId: string;
  date: string;
  filledFormId: string;
  status: string;
  createdAt: string;
  updatedAt: string;
}

interface ScheduleCompletedStatusProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  selectedDate: Date | undefined;
  selectedTime: string | null;
  title?: string;
  subtitle?: string;
  description?: string;
  onClose?: () => void;
  scheduleResponse?: ScheduleResponse | null;
}

const ScheduleCompletedStatus: React.FC<ScheduleCompletedStatusProps> = ({
  open,
  onOpenChange,
  selectedDate,
  selectedTime,
  title = "Agendamento realizado com sucesso",
  subtitle,
  description,
  onClose,
  scheduleResponse,
}) => {
  if (!selectedDate || !selectedTime) return null;

  const formattedDate = format(selectedDate, "dd 'de' MMMM 'de' yyyy", { locale: ptBR });
  
  // Gerar um ID de agendamento para exibição
  const scheduleId = scheduleResponse?._id 
    ? scheduleResponse._id.substring(0, 8) + '...'
    : 'Pendente';

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-[90vw] max-w-[425px] bg-white/10 backdrop-blur-sm border border-white/10 mx-4">
        <div className="p-4 sm:p-6 md:p-[40px] flex flex-col items-center text-center">
          <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-[64px] md:h-[64px] rounded-full bg-[#1777CF]/80 flex items-center justify-center mb-3 sm:mb-4 md:mb-[16px]">
            <Check className="w-6 h-6 sm:w-7 sm:h-7 md:w-[32px] md:h-[32px] text-white" />
          </div>
          <h2 className="text-base sm:text-lg md:text-[20px] font-semibold text-white mb-3 sm:mb-4 md:mb-[16px]">
            {title}
          </h2>
          
          <div className="bg-white/5 border border-white/10 p-3 sm:p-4 md:p-[16px] rounded-[8px] mb-3 sm:mb-4 md:mb-[16px] w-full">
            <p className="font-medium text-white">Data: <span className="font-normal text-white/80">{formattedDate}</span></p>
            <p className="font-medium text-white">Horário: <span className="font-normal text-white/80">{selectedTime}</span></p>

          </div>
          
          <p className="text-sm sm:text-base md:text-[16px] text-white/80 mb-4 sm:mb-5 md:mb-[24px]">
            {description || "Entraremos em contato para combinar os detalhes do agendamento."}
          </p>
          
          
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ScheduleCompletedStatus; 